import React, { PureComponent } from 'react';

import { DataTable } from 'components/dataTable';
import DataTableHeaderCell from 'components/dataTable/DataTableHeaderCell';

import './CommentListTableHeader.scss';

export default class CommentListTableHeader extends PureComponent {
  render() {
    return (
      <DataTable.Header className="comment-list__data-table__header">
        <DataTable.Row>
          <DataTable.SelectAll />
          <DataTable.Header.Columns />
          <DataTableHeaderCell className="user-list__actions-header" />
        </DataTable.Row>
      </DataTable.Header>
    );
  }
}
